import { Component, NgZone, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';

import { ToolbarService } from '../../services/toolbar.service';
import { VersionService } from '../../services/version.service';
import { EmailCodeService } from '../../services/email-code.service';
import { AppUrls } from '../../app.urls';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  passwordLoginForm: FormGroup;

  emailLoginForm: FormGroup;
  emailCodeLoginForm: FormGroup;
  email: string;
  emailCodeSent: boolean;

  loading = false;
  errorMessage: string = undefined;
  envHint: string;
  appVersion: string;


  constructor(
    private auth: AngularFireAuth,
    private formBuilder: FormBuilder,
    private router: Router,
    private ngZone: NgZone,
    private versionService: VersionService,
    private toolbarService: ToolbarService,
    private emailCodeService: EmailCodeService,
  ) {
    this.appVersion = versionService.appVersion();
  }

  ngOnInit(): void {
    this.passwordLoginForm = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required]],
      password: ['', Validators.required]
    });
    this.emailLoginForm = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required]]
    });
    this.emailCodeLoginForm = this.formBuilder.group({
      code: ['', [Validators.required, Validators.pattern(/[0-9a-zA-Z]{6}/)]]
    });
    this.auth.authState.subscribe({
      next: user => {
        if (user) {
          console.log(`User authenticated: ${user.email}, proceeding to startup screen`);
          this.ngZone.run(() => this.router.navigate([AppUrls.ROOT, AppUrls.Startup], { replaceUrl: true }));
        }
      }
    });
    this.envHint = environment.production ? '' : `Environment: ${environment.name}`;
    this.toolbarService.setToolbarConfig(undefined);
  }

  get enableSignInViaEmail(): boolean {
    return this.passwordLoginForm.controls.email.valid;
  }

  signInWithPassword(): void {
    this.errorMessage = undefined;

    // stop here if form is invalid
    if (this.passwordLoginForm.invalid) {
      this.errorMessage = 'Emailadresse und Passwort sind nötig.'; // TODO: i18n
      return;
    }

    this.loading = true;
    this.auth.signInWithEmailAndPassword(
      this.passwordLoginForm.value.email, this.passwordLoginForm.value.password)
      .catch((err) => {
        this.errorMessage = err.message;
        console.error(`Login failed: ${err}`);
        this.loading = false;
      });
  }

  sendEmailCode(): void {
    if (!this.emailLoginForm.controls.email.valid) {
      return;
    }

    this.errorMessage = undefined;
    this.emailCodeSent = false;
    this.loading = true;
    const email = this.emailLoginForm.value.email;
    this.emailCodeService.sendEmailCode(email)
      .then(() => {
        this.emailCodeSent = true;
        this.email = email;
      })
      .catch(error => {
        this.errorMessage = error.toString();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  verifyEmailCode(): void {
    if (!this.emailCodeLoginForm.controls.code.valid) {
      return;
    }

    this.errorMessage = undefined;
    this.loading = true;
    const code = this.emailCodeLoginForm.value.code;
    const email = this.emailLoginForm.value.email;
    this.emailCodeService.verifyEmailCode(email, code)
      .then(() => {
      })
      .catch(error => {
        this.errorMessage = error.toString();
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
